import {
	normalizeSizeParam,
	decodeLegacyMacroPageParam,
} from '@confluence/office-macro-utils/entry-points/macroParamsUtils.ts';

const DEFAULT_MEDIA_VIEWER_WIDTH = '95%';
const DEFAULT_MEDIA_VIEWER_HEIGHT = '650px';
const DEFAULT_HTML_VIEWER_WIDTH = '100%';
const DEFAULT_HTML_VIEWER_HEIGHT = '650px';

export type ViewXlsMacroParams = {
	''?: { value?: string };
	defaultParameterValue?: { value?: string };
	name?: { value?: string };
	page?: { value?: string };
	date?: { value?: string };
	space?: { value?: string };
	width?: { value?: string };
	height?: { value?: string };
};

export type ParsedViewXlsMacroParams = {
	attachmentName: string | null;
	pageName: string | null;
	spaceKey: string | null;
	date: string | null;
	mediaViewerWidth: string;
	mediaViewerHeight: string;
	htmlViewerWidth: string;
	htmlViewerHeight: string;
};

export const parseViewXlsMacroParams = (
	macroParams?: ViewXlsMacroParams,
): ParsedViewXlsMacroParams => {
	const attachmentName =
		macroParams?.name?.value ??
		macroParams?.['']?.value ??
		macroParams?.defaultParameterValue?.value ??
		null;

	const decodedPage = decodeLegacyMacroPageParam(macroParams?.page?.value ?? null);

	const rawWidth = macroParams?.width?.value;
	const rawHeight = macroParams?.height?.value;

	return {
		attachmentName,
		pageName: decodedPage.pageName,
		spaceKey: macroParams?.space?.value ?? decodedPage.spaceKey,
		date: macroParams?.date?.value ?? decodedPage.date,
		mediaViewerWidth: rawWidth ? normalizeSizeParam(rawWidth) : DEFAULT_MEDIA_VIEWER_WIDTH,
		mediaViewerHeight: rawHeight ? normalizeSizeParam(rawHeight) : DEFAULT_MEDIA_VIEWER_HEIGHT,
		htmlViewerWidth: rawWidth ? normalizeSizeParam(rawWidth) : DEFAULT_HTML_VIEWER_WIDTH,
		htmlViewerHeight: rawHeight ? normalizeSizeParam(rawHeight) : DEFAULT_HTML_VIEWER_HEIGHT,
	};
};

/**
 * Returns true when the file extension starts with "xls" (covers .xls and .xlsx).
 */
export const isExcelFile = (filename: string): boolean => {
	const dotIdx = filename.lastIndexOf('.');
	if (dotIdx === -1) {
		return false;
	}
	return filename
		.substring(dotIdx + 1)
		.toLowerCase()
		.startsWith('xls');
};

/**
 * Truncates a filename to at most 35 characters for display in notices.
 * Matches legacy ConverterMacro.truncateFileName() behaviour.
 */
export const truncateFileName = (filename: string): string => {
	if (filename.length > 35) {
		return filename.substring(0, 10) + '...' + filename.substring(filename.length - 15);
	}
	return filename;
};
